'use client';

import { SearchItemWithImageViewModel } from '@/types/api';
import { AppNextLink } from '@/features/app-next-link';
import { useUserToken } from '@/features/user-token-provider/use-user-token';
import { sendCardDataClickEvent } from '@/utils/send-card-data-click-event';
import { useSearchModal } from './context/search-modal-context';
interface Props {
  href: string;
  children: React.ReactNode;
  className?: string;
  item: SearchItemWithImageViewModel;
  onClick?: (e: React.MouseEvent, href?: string) => void;
}
export default function MobileSearchLink({
  href,
  children,
  className,
  item,
  onClick
}: Props) {
  const {
    userToken
  } = useUserToken();
  const {
    close: closeSearchModal
  } = useSearchModal();
  const handleClick = (e: React.MouseEvent) => {
    if (item.queryId) sendCardDataClickEvent({
      userToken: userToken ?? '',
      id: item.id,
      queryId: item.queryId,
      type: item.type ?? null,
      position: item.position ?? null
    });
    if (onClick) {
      onClick(e, href);
    } else {
      closeSearchModal();
    }
  };
  return <AppNextLink prefetch={false} onClick={handleClick} href={href} className={className} data-sentry-element="AppNextLink" data-sentry-component="MobileSearchLink" data-sentry-source-file="mobile-search-link.tsx">
            {children}
        </AppNextLink>;
}